module.exports = __webpack_public_path__ + "static/media/lululemon.f1d1aef6.png";